export default __webpack_public_path__ + "static/media/whatsappIcon.21208873.svg";